module.exports = __webpack_public_path__ + "static/media/6.5-inch Screenshot 3.7b5ca409.jpeg";